// extracted by mini-css-extract-plugin
module.exports = {"frame_container":"index-module--frame_container--7ocN_","icon_close":"index-module--icon_close--vIsRV","frame":"index-module--frame--1O-sw"};